<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Tarea: {{task.title}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <b-button variant="outline-secondary" to="/tareas/nuevo">Nueva</b-button>
                        <b-button variant="outline-primary" :to="'/tareas/editar/' + this.$route.params.id">Editar
                        </b-button>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <template v-else>
                <b-row>
                    <b-col class="md-12">
                        <b-list-group>
                            <b-list-group-item><b>Nombre:</b><span>{{task.title}}</span></b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="md-12">
                        <b-list-group>
                            <b-list-group-item><b>Descripción:</b><span v-html="task.content"></span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="md-12">
                        <b-list-group>
                            <b-list-group-item><b>Etapa:</b><span>
                                <b-link v-bind:to="'/etapas/' + task.stage.value">{{task.stage.label}}</b-link>
                            </span></b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="md-12">
                        <b-list-group>
                            <b-list-group-item><b>Finalizado:</b><span
                                    v-html="(task.finished === true ) ? 'Finalizado' : 'En progreso'"></span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="md-12">
                        <b-list-group>
                            <b-list-group-item><b>Fecha de finalización:</b><span>{{task.finish_date  | moment("DD/MM/YYYY") }}</span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>


                <b-row>
                    <b-col class="md-12">

                        <br><h3 class="h5">Documentos</h3>

                                <b-table hover v-bind:items="task.documents" v-bind:fields="documentHeaders"
                                         outlined
                                         head-variant="light">
                                    <template slot="file" slot-scope="data">
                                        <b-link v-bind:to="data.item.file.url" target="_blank">{{data.item.file.name}}</b-link>
                                    </template>
                                    <template slot="title" slot-scope="data">
                                        {{data.item.title}}
                                    </template>
                                </b-table>

<!--                        <b-list-group>-->
<!--                            <b-list-group-item><b>Adjunto(s):</b><span><a :href="task.attachment.url">{{task.attachment.filename}}</a>-->
<!--                            </span></b-list-group-item>-->
<!--                        </b-list-group>-->
                    </b-col>
                </b-row>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "TasksView",
        data() {
            return {
                isLoading: true,
                documents: [],
                documentHeaders: [
                    {key: 'file', label: 'Archivo', sortable: false},
                    {key: 'title', label: 'Título', sortable: false}
                ],
            }
        },
        computed: {
            ...mapGetters({
                task: 'tasks/getEntries',
            })
        },
        created() {
            this.isLoading = true;

            this.$store.dispatch('tasks/loadEntries', this.$route.params.id).then(() => {
                this.isLoading = false;
            });

        }
    }
</script>

<style scoped>
    .list-group-item > b {
        flex: 2;
    }

    .thumb {
        max-width: 128px;
    }
</style>